<script lang="ts" setup>
import { KsDrawer } from '@aschehoug/kloss'

defineProps<{ open: boolean }>()
const emit = defineEmits(['close'])

const { isAuthenticated, logout } = useAuthStore()

// Pre-fetch license details to avoid
// flickering when the drawer is opened
useLicenseDetails()
</script>

<template>
  <KsDrawer
    :title="''"
    position="top"
    size="auto"
    :open="open"
    :dismissable="false"
    @close="emit('close')"
  >
    <template #header>
      <AppSettingsHeader @close="emit('close')" />
    </template>
    <template #body>
      <AppSettingsUserOverview />

      <div class="container">
        <AppSettingsLicenseOverview />
        <hr>
        <AppSettingsLanguageSelector />
      </div>

      <div class="bottom">
        <CommonButton
          v-if="isAuthenticated"
          is-on-dark
          class="logout"
          @click="logout"
        >
          {{ $t('app.logout') }}
        </CommonButton>
      </div>
    </template>
  </KsDrawer>
</template>

<style lang="scss" scoped>
  :deep(.ks-dialog) {
    top: 14px;
    right: 24px;
    bottom: 14px;
    left: unset;
    gap: 4px;
    border-radius: 0;
    max-width: 568px;
    width: 100%;
    max-height: 100%;
    background-color: var(--color-blue-50);
    color: var(--color-yellow-10);
    padding: 20px 40px 40px;

    @include vgs-media-mobile {
      padding: 20px 16px 40px;
      inset: 0;
      left: unset;
    }

    .ks-dialog-header {
      padding: 0;
    }

    .ks-dialog-body {
      display: flex;
      flex-direction: column;
      gap: 40px;
      padding: 0;
    }
  }

  .container {
    padding: 24px;
    background-color: var(--color-yellow-10);
    color: var(--color-blue-50);
    display: flex;
    flex-direction: column;
    gap: 24px;

    hr {
      all: unset;
      border-top: 1px solid var(--color-blue-30);
      width: 100%;
      margin-bottom: 8px;
    }
  }

  .bottom {
    padding-bottom: 40px;
    margin-left: auto;
  }

  .logout {
    align-self: flex-end;

    @include vgs-media-mobile {
      display: flex;
    }
  }
</style>
